import { PortalLegalRoute } from './portalLegalRouteConstants';

function resolveLegalHref(envValue: string | undefined, fallbackRoute: string): string {
  const trimmed = envValue?.trim();
  return trimmed && trimmed.length > 0 ? trimmed : fallbackRoute;
}

export function resolvePrivacyPolicyHref(): string {
  return resolveLegalHref(
    import.meta.env.VITE_PORTAL_PRIVACY_POLICY_URL,
    PortalLegalRoute.PRIVACY_POLICY,
  );
}

export function resolveTermsAndConditionsHref(): string {
  return resolveLegalHref(
    import.meta.env.VITE_PORTAL_TERMS_URL,
    PortalLegalRoute.TERMS_AND_CONDITIONS,
  );
}
